import CardsLayout, {SELECTORS as CARDS_LAYOUT} from "../CardsLayout/CardsLayout";

export const SELECTORS = {
    root:                   '.js-content-hub-filter',
    teaser:                 '.js-content-hub-filter-teaser',
    categories:             '.js-content-hub-filter-categories',
    teaserCategories:       '.js-content-hub-filter-teaser .js-content-hub-filter-categories',
    category:               '.js-content-hub-category',
    categoryCheckbox:       '.js-content-hub-filter-category-checkbox',
    types:                  '.js-content-hub-filter-types',
    type:                   '.js-content-hub-filter-type',
    typeCheckbox:           '.js-content-hub-filter-type-checkbox',
    checkbox:               '.js-content-hub-filter input.checkbox',
    submit:                 '.js-content-hub-filter-submit',
    form:                   '.js-content-hub-filter',
    description:            '.js-content-hub-filter-category-description > p',
    title:                  '.js-content-hub-filter-category-title',
    reset:                  '.js-content-hub-filter-reset',
    more:                   '.js-content-hub-filter-more',
    teaserSubmit:           '.js-content-hub-filter-teaser-submit',
    header:                 '.js-header',
    loadMore:               '.js-content-hub-loadmore-wrapper',
};

export const CLASSES = {
    active: 'active',
    opened: 'opened',
    closed: 'closed',
};

export const CONSTANTS = {
    defaultCategoryTitle: '',
    defaultCategoryDescription: '',
};

export default class Filter {
    constructor(element) {
        this.SELECTORS = SELECTORS;

        this.CLASSES = CLASSES;

        this.CONSTANTS = CONSTANTS;

        /**
         * Cards Block Listing
         * @type {jQuery|HTMLElement}
         */
        this.ELEMENT = element;

        this.initComponents().then(_ => {
            this.onLoad();
            this.registerHooks();
        });

    }

    initComponents() {
        const _this = this;

        return new Promise(resolve => {
            if (_this.SELECTORS.categories.length > 0) {
                _this.setDefaultCategoryText();
                resolve();
            }
        });
    }

    registerHooks() {
        const _this = this;

        // click event for filter items
        $(_this.SELECTORS.categories)
            .not(_this.SELECTORS.teaserCategories)
            .on('change', _this.SELECTORS.categoryCheckbox, event => {
                let $filterItem = $(event.currentTarget),
                    filterItemTitle = $(event.currentTarget).parent().find(_this.SELECTORS.title).text(),
                    filterItemDescription = $(event.currentTarget).parent().find(_this.SELECTORS.description).text();

                _this.setCurrentCategoryTexts(filterItemTitle, filterItemDescription);
                _this.setCurrentCategoryActiveClass($filterItem);
                _this.setCurrentCategoryCheckboxState($filterItem);

                //reset type filters when a category is selected
                _this.resetTypeFilters();

                _this.formChecked();

                _this.updateTypeFilters();

                // submit form
                //$(_this.SELECTORS.form).submit();
            });

        // teaser categories change event
        $(_this.SELECTORS.teaserCategories)
            .on('change', this.SELECTORS.categoryCheckbox, event => {
                let $filterItem = $(event.currentTarget),
                    $li = $filterItem.closest('li'),
                    $filters = $filterItem.closest(_this.SELECTORS.root),
                    headerOffset = $(_this.SELECTORS.header).height() + 40;

                _this.toggleTeaserAcc($filterItem, $li);
                //_this.scrollToTop($filters, 350, headerOffset);
            });

        // type filters change event
        $(_this.SELECTORS.form).on('change', _this.SELECTORS.typeCheckbox, event => {
            _this.checkboxesChecked();
        });

        // reset click event
        $(_this.SELECTORS.reset).on('click',  event => {
            let $item = $(event.currentTarget);
            event.preventDefault();

            if ($((_this.SELECTORS.teaserCategories)).length) {
                $item.parent().find(_this.SELECTORS.categoryCheckbox).trigger('change');
            } else {
                _this.resetFilters();
            }
        });

        // more click event
        $(_this.SELECTORS.more).on('click', event => {
            let $item = $(event.currentTarget);
            event.preventDefault();

            $item.parent().find(_this.SELECTORS.categoryCheckbox).trigger('change');
        });

        // teaser submit
        $(_this.SELECTORS.teaserSubmit).on('click', event => {
            this.updateTypeFilters();
        });
    }

    onLoad() {
        const _this = this;

        if (!$(_this.SELECTORS.teaserCategories).length) {
            $(_this.SELECTORS.categoryCheckbox).each(function () {
                if ($(this).is(':checked')) {
                    let $filterItem = $(this),
                        filterItemTitle = $(this).parent().find(_this.SELECTORS.title).text(),
                        filterItemDescription = $(this).parent().find(_this.SELECTORS.description).text();

                    _this.setCurrentCategoryTexts(filterItemTitle, filterItemDescription);
                    _this.setCurrentCategoryActiveClass($filterItem);
                    _this.setCurrentCategoryCheckboxState($filterItem);
                    _this.updateTypeFilters();
                    _this.formChecked();
                }
            });
        }
    }

    checkboxesChecked(){
        const _this = this;

        $(_this.SELECTORS.checkbox).each((i, item) => {
            let $item = $(item);

            _this.formChecked();
        });

        // submit form
        _this.removeLoadMore();
        $(_this.SELECTORS.form).submit();
    }

    /**
     * toggle filter item teaser accordion
     * @param $filterItem
     * @param $list
     */
    toggleTeaserAcc($filterItem, $list) {
        const _this = this;

        // reset filter items
        $(_this.SELECTORS.categoryCheckbox).prop('checked', false);
        $list.siblings().removeClass([_this.CLASSES.active, _this.CLASSES.opened]).addClass(_this.CLASSES.closed);

        // check if item is already opened
        if ($list.hasClass(_this.CLASSES.opened)) {
            // close; bring to default state
            $filterItem.prop('checked', false);
            $list.removeClass([_this.CLASSES.opened, _this.CLASSES.closed]).addClass(_this.CLASSES.active);
            $list.siblings().removeClass([_this.CLASSES.opened, _this.CLASSES.closed]).addClass(_this.CLASSES.active);
        } else {
            // open
            $filterItem.prop('checked', true);
            $list.removeClass(_this.CLASSES.closed).addClass([_this.CLASSES.opened, _this.CLASSES.active]);

            //_this.scrollToTop($list, 350);
        }
    }

    scrollToTop($target, slideDuration, headerOffset) {
        let _this = this;

        setTimeout(_ => {
            $('html, body').animate({
                scrollTop: $target.offset().top - headerOffset
            }, slideDuration);
        }, slideDuration);
    }

    /**
     * set default category texts
     */
    setDefaultCategoryText() {
        const _this = this;

        _this.CONSTANTS.defaultCategoryTitle = $('.intro').find('h1').text();
        _this.CONSTANTS.defaultCategoryDescription = $('.frame').first().find('.ce-bodytext > p').text();
    }

    /**
     * replace intro headline and first text w/ current category settings
     * @param filterItemTitle
     * @param filterItemDescription
     */
    setCurrentCategoryTexts(filterItemTitle, filterItemDescription) {
        const _this = this;

        let $headline = $('.intro').find('h1'),
            $text     = $('.frame').first().find('.ce-bodytext > p');

        $headline.text(filterItemTitle);

        if ($text.length > 0) {
            $text.text(filterItemDescription);
        } else {
            $headline.closest('.intro').next('.frame').first().find('.content-bodytext').append('<div class="ce-bodytext"><p>'+ filterItemDescription +'</p></div>');
        }
    }

    /**
     * reset current category texts to default
     */
    resetCategoryText() {
        const _this = this;

        let $headline = $('.intro').find('h1'),
            $text     = $('.frame').first().find('.ce-bodytext > p');

        $headline.text(_this.CONSTANTS.defaultCategoryTitle);

        if ($text.length > 0) {
            $text.text(_this.CONSTANTS.defaultCategoryDescription);
        } else {
            $headline.closest('.intro').next('.frame').first().find('.content-bodytext').append('<div class="ce-bodytext"><p>'+ _this.CONSTANTS.defaultCategoryDescription +'</p></div>');
        }
    }

    /**
     * set active class for clicked category
     * @param $filterItem
     */
    setCurrentCategoryActiveClass($filterItem) {
        const _this = this;

        $(_this.SELECTORS.category).each((i, item) => {
            let $item = $(item);

            $item.removeClass(_this.CLASSES.active);
        });

        $filterItem.closest(_this.SELECTORS.category).addClass(_this.CLASSES.active);
    }

    /**
     * set checkbox attributes for clicked category
     * @param $filterItem
     */
    setCurrentCategoryCheckboxState($filterItem) {
        const _this = this;

        $(_this.SELECTORS.category).each((i, item) => {
            let $item = $(item);

            $item.find(_this.SELECTORS.categoryCheckbox).prop('checked', false);
        });

        $filterItem.prop('checked', true);
    }

    /**
     * reset category filters function
     */
    resetCategoryFilters() {
        const _this = this;
        $(_this.SELECTORS.categoryCheckbox).prop('checked', false);
        $(_this.SELECTORS.category).addClass(_this.CLASSES.active);
        _this.resetCategoryText();
    }

    /**
     * reset type filters function
     */
    resetTypeFilters() {
        const _this = this;
        $(_this.SELECTORS.typeCheckbox).prop('checked', false);
    }

    /**
     * reset all filters function
     */
    resetFilters() {
        const _this = this;
        _this.resetCategoryFilters();
        _this.resetTypeFilters();
        _this.formChecked();

        _this.updateTypeFilters();
    }

    /**
     * validate if checkboxes are checked
     */
    formChecked() {
        const _this = this;

        if ($(_this.SELECTORS.checkbox).is(':checked')) {
            $(_this.SELECTORS.form).addClass('checked');
        } else {
            $(_this.SELECTORS.form).removeClass('checked');
        }
    }

    /**
     * remove all load more buttons except one
     */
    removeLoadMore() {
        const _this = this;
        $(_this.SELECTORS.loadMore).each((i, element) => {
            if(i <= $(_this.SELECTORS.loadMore).length) {
                $(element).remove();
            } else {}
        })
    }

    updateTypeFilters() {
        const _this = this;

        let $url = $(_this.SELECTORS.types).attr('data-update-url');
        let $data = $(SELECTORS.form).serializeArray();
        $(CARDS_LAYOUT.elementWrapper).removeClass('initial');
        $(CARDS_LAYOUT.elementWrapper).removeClass('show');

        $.ajax({
            method: 'POST',
            url: $url,
            cache: false,
            data: $.param($data),
            success: function (result) {
                _this.removeLoadMore();

                $('#typeFilter').html($(result).find('#output').html());
            },
            complete: function () {
                $(_this.SELECTORS.form).on('change', _this.SELECTORS.typeCheckbox, event => {
                    _this.checkboxesChecked();
                });
                // submit form
                $(_this.SELECTORS.form).submit();
            }
        });
    }
}
